/**
 * 社区排行榜的状态管理
 */
import { GET, URLS } from '../../utils'
import { types as TipTypes } from './tip'
import { types as LoadingTypes } from './loading'

export const types = {
  // 列表请求
  FETCH_LIST_RANK: 'RANK/FETCH_LIST_RANK',
  // 列表回调处理
  LOAD_LIST_RANK: 'RANK/LOAD_LIST_RANK'
}

const state = {
  data: [] // 数据源列表
}

const mutations = {
  [types.LOAD_LIST_RANK] (state, param) {
    state.data = param
  }
}

const actions = {
  /**
   * 列表
   */
  [types.FETCH_LIST_RANK] ({ dispatch, commit, state, rootState, rootGetter }, param_data) {
    let type = param_data
    commit(LoadingTypes.SHOW)
    let url = URLS.list_rank(type)
    GET(url).then(response => {
      commit(types.LOAD_LIST_RANK, response)
      commit(LoadingTypes.HIDE)
    })
  }
}

const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}
